import { useContext, useState } from "react";
import { AppContext } from "../../AppContext";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import NavbarV2 from "../global-components/navbar-v2";
import Footer_v1 from "../global-components/footer";

const getYouTubeID = (url) => {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]+)/
  );
  return match ? match[1] : null;
};

const PodcastDetails = () => {
    
  const { podcasts } = useContext(AppContext);
  const podcastList = Array.isArray(podcasts) ? podcasts : podcasts?.data || [];
  const [activeVideoId, setActiveVideoId] = useState(null); // Main
  const [playingVideos, setPlayingVideos] = useState({}); // Similar
  const { sendClickStatus } = useContext(AppContext);

  const baseUrl = "https://hondaapi.clientcoding.com/";
  const publicUrl = process.env.PUBLIC_URL + "/";

  const truncate = (str, n) =>
    str && str.length > n ? str.slice(0, n) + "..." : str || "";

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  console.log(podcastList, "lpp");
  if (!podcastList.length) return <p>No podcast data available.</p>;

  return (
    <>
      <NavbarV2 />
      <div>
        <img src="/assets/rajiv.jpeg" alt="" className="fb-images"/>
      </div>
      <div className="post-area banner-post-area pt-4 pd-bottom-70">
        <div className="container">
          <div className="row">
            {/* Main Podcast */}
            {podcastList.length > 0 && (
              <div className="col-lg-6 mb-1">
                <div className="single-post-wrap style-overlay">
                  <div
                    className=" cd"
                    onClick={() => {
                      sendClickStatus(podcastList[0].id, "click");
                    }}
                  >
                    {activeVideoId === podcastList[0].id ? (
                      <iframe
                        width="100%"
                        height="315"
                        src={`https://www.youtube.com/embed/${getYouTubeID(
                          podcastList[0].youtube_link
                        )}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <img
                        src={`${baseUrl}${podcastList[0].thumbnail}`}
                        alt={podcastList[0].title}
                        style={{
                          maxWidth: "100%",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => setActiveVideoId(podcastList[0].id)}
                      />
                    )}
                  </div>
                  <div className="details ">
                    <Link to={podcastList.youtube_link}>
                      <h5 className="title black">
                        {truncate(podcastList[0].title, 50)}
                      </h5>
                    </Link>
                    <Link to={podcastList.youtube_link}>
                      <p className="text-sm black">
                        {formatDate(podcastList[0].date)}
                      </p>
                    </Link>
                  </div>
                </div>
              </div>
            )}

            {/* Similar Podcasts */}
            <div className="col-lg-3 col-sm-6">
              <div className="section-title style-two mb-4">
                <h6 className="title black"> Podcast Shoot</h6>
              </div>
              {podcastList.slice(1).map((podcast) => (
                <div key={podcast.id} className="mb-4">
                  <div className="media">
                    <div
                      className="media-left mr-3 "
                      onClick={() => {
                        sendClickStatus(podcastList[0].id, "click");
                      }}
                    >
                      {playingVideos[podcast.id] ? (
                        <iframe
                          height="500"
                          src={`https://www.youtube.com/embed/${getYouTubeID(
                            podcast.youtube_link
                          )}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <img
                          src={`${baseUrl}${podcast.thumbnail}`}
                          alt={podcast.title}
                          style={{
                            width: "100px",
                            height: "85px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setPlayingVideos((prev) => ({
                              ...prev,
                              [podcast.id]: true,
                            }))
                          }
                        />
                      )}
                    </div>
                    <div className="media-body">
                      <h6 className="title">{truncate(podcast.title, 50)}</h6>
                      <p className="text-muted">{formatDate(podcast.date)}</p>

                      <div
                        className="d-flex gap-3"
                        onClick={() => {
                          sendClickStatus(podcastList[0].id, "click");
                        }}
                      >
                        {podcast.reels.length > 0 &&
                          podcast.reels[0].facebook_link && (
                            <div className="mr-2">
                              <a
                                href={podcast.reels[0].facebook_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-flex justify-content-center align-items-center"
                                style={{
                                  borderRadius: "50px",
                                  height: "30px",
                                  width: "30px",
                                  background: "rgb(48 120 250)",
                                  padding: "10px",
                                  color: "#fff",
                                }}
                              >
                                <i className="fa fa-facebook"></i>
                              </a>
                            </div>
                          )}
                        {podcast.reels.length > 0 &&
                          podcast.reels[0].youtube_link && (
                            <div className="">
                              <a
                                href={podcast.reels[0].youtube_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-flex justify-content-center align-items-center"
                                style={{
                                  borderRadius: "50px",
                                  height: "30px",
                                  width: "30px",
                                  background: "#d42428",
                                  padding: "10px",
                                  color: "#fff",
                                }}
                              >
                                <i className="fa fa-youtube-play"></i>
                              </a>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Category Section */}
            <div className="col-lg-3 col-sm-6 widget-category">
              <div className="section-title style-two mb-4">
                <h6 className="title">Category</h6>
              </div>
              <div className="row custom-gutters-14">
                {[
                  { name: "न्यूज़", img: "news.jpg" },
                  { name: "मनोरंजन", img: "manoranjan.jpeg" },
                  { name: "हेल्थ", img: "health.webp" },
                  {
                    name: "वेब स्टोरी",
                    img: "trending.webp",
                    path: "web-stories",
                  },
                  { name: "धर्म", img: "dharam.avif" },
                  { name: "बिजनेस", img: "business.jpg" },
                ].map((cat, idx) => (
                  <div className="col-sm-6" key={idx}>
                    <div className="single-category-inner">
                      <img
                        src={publicUrl + "assets/img/" + cat.img}
                        alt="img"
                        height={75}
                      />
                      <Link
                        className="tag-base tag-blue"
                        to={`/category/${cat.path || cat.name}`}
                      >
                        {cat.name}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer_v1 />
    </>
  );
};

export default PodcastDetails;
